import { EcoaContent } from "@components/common/EconContent";
import React from "react";
import { CrfConstantItemSpec } from "maven-lib/dist/consts/edc";
import { EcoaQuestionnaire } from "maven-lib/dist/dto/entity/ecoaVisit";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";

interface QuestionnaireConstantItemProps {
  questionnaire: EcoaQuestionnaire;
  item: CrfConstantItemSpec;
}

export function QuestionnaireConstantItem({ item }: QuestionnaireConstantItemProps) {
  const values = item.value.split("\n");

  return (
    <EcoaContent>
      {values.map((value, idx) => (
        <HbParagraph key={idx} text={value} bold={true} size={"X-LARGE"} />
      ))}
    </EcoaContent>
  );
}
